import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State { return { error } }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Ops Matrix recovered from a screen error', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return <main className="centred-page" id="main-content" tabIndex={-1}>
      <section className="auth-card panel" role="alert">
        <span className="overline">Safe recovery</span>
        <h1>This screen could not be shown</h1>
        <p>Your saved data has not been deleted. Reload the latest saved version, or return to Today.</p>
        <div className="button-row">
          <button className="button button-primary" type="button" onClick={() => location.reload()}>Reload saved data</button>
          <a className="button" href="/?screen=today">Return to Today</a>
        </div>
        <details><summary>Technical detail</summary><code className="error-detail">{this.state.error.message}</code></details>
      </section>
    </main>
  }
}
